<ng-container *ngIf="step !== 20">
    <div class="cas-onboarding-wrapper">
        <div class="onboarding-step-header">{{step}}</div>
        <ng-container *ngIf="step === 1">
            <acabim-admin-onboarding-actions-auto-execute></acabim-admin-onboarding-actions-auto-execute>
        </ng-container>
        <ng-container *ngIf="step === 2">
            <acabim-admin-onboarding-building-assets-auto-generate></acabim-admin-onboarding-building-assets-auto-generate>
        </ng-container>
        <ng-container *ngIf="step === 3">
            <acabim-admin-onboarding-ltm-items-auto-generate></acabim-admin-onboarding-ltm-items-auto-generate>
        </ng-container>
        <ng-container *ngIf="step === 4">
            <acabim-admin-onboarding-branding></acabim-admin-onboarding-branding>
        </ng-container>
        <ng-container *ngIf="step === 5">
            <acabim-admin-onboarding-financial-enable (completed)="handleFinancial($event)"></acabim-admin-onboarding-financial-enable>
        </ng-container>
        <ng-container *ngIf="step === 6">
            <acabim-admin-onboarding-financial-dates></acabim-admin-onboarding-financial-dates>
        </ng-container>
        <ng-container *ngIf="step === 7">
            <acabim-admin-onboarding-financial-currency-tax></acabim-admin-onboarding-financial-currency-tax>
        </ng-container>
        <ng-container *ngIf="step === 8">
            <acabim-admin-onboarding-financial-maintenance></acabim-admin-onboarding-financial-maintenance>
        </ng-container>

        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button *ngIf="step > 1" type="button" (click)="onNext(step - 1)" class="_t-cancel-button">Back</button>
            <button type="button" (click)="onCancel(true)" class="_t-cancel-button">Close</button>
            <button type="button" class="cas-button-action cas-button-right _t-next-button" (click)="onNext(step + 1)">{{nextLabel}}</button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="step === 20">
    <div class="cas-info">
        <h4 data-cy="_t-all-done-message">Done!</h4>
        <button class="cas-button-action all-done push-up-3" data-cy="_t-all-done" (click)="onDone()">Ok</button>
    </div>
</ng-container>
